import { render } from "./IntroSectionXxl.vue?vue&type=template&id=3833f834&scoped=true"
import script from "./IntroSectionXxl.vue?vue&type=script&lang=js"
export * from "./IntroSectionXxl.vue?vue&type=script&lang=js"

import "./IntroSectionXxl.vue?vue&type=style&index=0&id=3833f834&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3833f834"]])

export default __exports__